import { render } from "./ContactHubsPage.vue?vue&type=template&id=c4975f7e"
import script from "./ContactHubsPage.vue?vue&type=script&lang=js"
export * from "./ContactHubsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__